// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  PhoneControl,
  InputControl,
  FormatInputControl,
  DatePickerControl,
  SelectControl
} from "../../molecules";
import {
  Box,
  FormControl,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { useForm } from "react-hook-form";
import { Button, Loading } from "../../atoms";
import {
  IMerchantPartnerAddRequest,
  useMerchantPartnerAdd,
  IMerchant,
  useMerchantPartnerUpdate,
  useMerchantPartnerDelete
} from "../../../hooks";
import { useEffect } from "react";
import { useUserMerchantId } from "./Merchant.state";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import {
  partnerStepFormSchema,
  PartnerStepFormValuesType,
  partnerStepInitialValues,
} from "./_formTypes";
import { zodResolver } from "@hookform/resolvers/zod";
import React from "react";
import { default as dayjs } from "dayjs";
import { formatPhoneNumber2 } from "../../../common/format";

type MerchantAddFormCompanyStepProps = {
  onNext: () => void;
  onBack: () => void;
  merchant?: any;
  allData?: any;
  setAllData?: any;
};

export const partnerTypeOptions = [
  { label: "Gerçek kişi", value: "G" },
  { label: "Tüzel kişi", value: "T" },
  { label: "Gerçek faydalanıcı", value: "F" },
];

export const MerchantAddFormPartnerStep = ({
  merchant,
  onNext,
  onBack,
  allData,
  setAllData,
}: MerchantAddFormCompanyStepProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const { mutate: addMerchantPartner, isLoading } = useMerchantPartnerAdd();
  const { mutate: updateMerchantPartner, isUpdateLoading } =
    useMerchantPartnerUpdate();

  const [merchantId] = useUserMerchantId();

  const { control, reset, handleSubmit, setValue, getValues } = useForm<PartnerStepFormValuesType>({
    resolver: zodResolver(partnerStepFormSchema),
    defaultValues: partnerStepInitialValues,
  });

  const setSnackbar = useSetSnackBar();

  const onSubmit = (formValues: PartnerStepFormValuesType) => {
    const request: IMerchantPartnerAddRequest = {
      merchantId: allData?.merchantId,
      officialFullName: formValues.officialFullName,
      officialCitizenNumber: formValues.officialCitizenNumber,
      officialMobilePhone: formValues.officialMobilePhone,
      officialBirthDate: formValues.officialBirthDate ? dayjs(formValues.officialBirthDate).format("YYYY-MM-DD") : null,

      partnerOneFullName: formValues.partnerOneFullName,
      partnerOneCitizenNumber: formValues.partnerOneCitizenNumber,
      partnerOneMobilePhone: null,
      partnerOneBirthDate: formValues.partnerOneBirthDate ? dayjs(formValues.partnerOneBirthDate).format("YYYY-MM-DD") : null,
      partnerOnePercent: formValues.partnerOnePercent || 0,
      partnerOneType: formValues.partnerOneType || "G",

      partnerTwoFullName: formValues.partnerTwoFullName,
      partnerTwoCitizenNumber: formValues.partnerTwoCitizenNumber,
      partnerTwoMobilePhone: null,
      partnerTwoBirthDate: formValues.partnerTwoBirthDate ? dayjs(formValues.partnerTwoBirthDate).format("YYYY-MM-DD") : null,
      partnerTwoPercent: formValues.partnerTwoPercent || 0,
      partnerTwoType: formValues.partnerTwoType || "G",

      partnerThreeFullName: formValues.partnerThreeFullName,
      partnerThreeCitizenNumber: formValues.partnerThreeCitizenNumber,
      partnerThreeMobilePhone: null,
      partnerThreeBirthDate: formValues.partnerThreeBirthDate ? dayjs(formValues.partnerThreeBirthDate).format("YYYY-MM-DD") : null,
      partnerThreePercent: formValues.partnerThreePercent || 0,
      partnerThreeType: formValues.partnerThreeType || "G",

      partnerFourFullName: formValues.partnerFourFullName,
      partnerFourCitizenNumber: formValues.partnerFourCitizenNumber,
      partnerFourMobilePhone: null,
      partnerFourBirthDate: formValues.partnerFourBirthDate ? dayjs(formValues.partnerFourBirthDate).format("YYYY-MM-DD") : null,
      partnerFourPercent: formValues.partnerFourPercent || 0,
      partnerFourType: formValues.partnerFourType || "G",

      partnerFiveFullName: formValues.partnerFiveFullName,
      partnerFiveCitizenNumber: formValues.partnerFiveCitizenNumber,
      partnerFiveMobilePhone: null,
      partnerFiveBirthDate: formValues.partnerFiveBirthDate ? dayjs(formValues.partnerFiveBirthDate).format("YYYY-MM-DD") : null,
      partnerFivePercent: formValues.partnerFivePercent || 0,
      partnerFiveType: formValues.partnerFiveType || "G",
    };

    setAllData({ ...allData, ...request });

    // const updateLocalStorageFromRequest = () => {
    //   try {
    //     const merchantDataRaw = localStorage.getItem("merchantData");
    //     if (!merchantDataRaw) return;
    //     const merchantData = JSON.parse(merchantDataRaw);

    //     merchantData["officialFullName"] = request.officialFullName || "";
    //     merchantData["officialCitizenNumber"] = request.officialCitizenNumber || "";
    //     merchantData["officialMobilePhone"] = request.officialMobilePhone || "";
    //     merchantData["officialBirthDate"] = request.officialBirthDate || null;

    //     merchantData["partnerOneFullName"] = request.partnerOneFullName || "";
    //     merchantData["partnerOneCitizenNumber"] = request.partnerOneCitizenNumber || "";
    //     merchantData["partnerOneMobilePhone"] = request.partnerOneMobilePhone || "";
    //     merchantData["partnerOneBirthDate"] = request.partnerOneBirthDate || null;
    //     merchantData["partnerOnePercent"] = request.partnerOnePercent || 0;
    //     merchantData["partnerOneType"] = request.partnerOneType || "G";

    //     merchantData["partnerTwoFullName"] = request.partnerTwoFullName || "";
    //     merchantData["partnerTwoCitizenNumber"] = request.partnerTwoCitizenNumber || "";
    //     merchantData["partnerTwoMobilePhone"] = request.partnerTwoMobilePhone || "";
    //     merchantData["partnerTwoBirthDate"] = request.partnerTwoBirthDate || null;
    //     merchantData["partnerTwoPercent"] = request.partnerTwoPercent || 0;
    //     merchantData["partnerTwoType"] = request.partnerTwoType || "G";

    //     merchantData["partnerThreeFullName"] = request.partnerThreeFullName || "";
    //     merchantData["partnerThreeCitizenNumber"] = request.partnerThreeCitizenNumber || "";
    //     merchantData["partnerThreeMobilePhone"] = request.partnerThreeMobilePhone || "";
    //     merchantData["partnerThreeBirthDate"] = request.partnerThreeBirthDate || null;
    //     merchantData["partnerThreePercent"] = request.partnerThreePercent || 0;
    //     merchantData["partnerThreeType"] = request.partnerThreeType || "G";

    //     merchantData["partnerFourFullName"] = request.partnerFourFullName || "";
    //     merchantData["partnerFourCitizenNumber"] = request.partnerFourCitizenNumber || "";
    //     merchantData["partnerFourMobilePhone"] = request.partnerFourMobilePhone || "";
    //     merchantData["partnerFourBirthDate"] = request.partnerFourBirthDate || null;
    //     merchantData["partnerFourPercent"] = request.partnerFourPercent || 0;
    //     merchantData["partnerFourType"] = request.partnerFourType || "G";

    //     merchantData["partnerFiveFullName"] = request.partnerFiveFullName || "";
    //     merchantData["partnerFiveCitizenNumber"] = request.partnerFiveCitizenNumber || "";
    //     merchantData["partnerFiveMobilePhone"] = request.partnerFiveMobilePhone || "";
    //     merchantData["partnerFiveBirthDate"] = request.partnerFiveBirthDate || null;
    //     merchantData["partnerFivePercent"] = request.partnerFivePercent || 0;
    //     merchantData["partnerFiveType"] = request.partnerFiveType || "G";

    //     localStorage.setItem("merchantData", JSON.stringify(merchantData));
    //   } catch (e) {
    //     // ignore
    //   }
    // };

    if ((merchant && merchant?.id > 0 && allData?.officialFullName) || (allData && allData?.officialFullName)) {
      updateMerchantPartner(
        { ...request, id: merchant?.id || 0 },
        {
          onSuccess(data) {
            if (data.isSuccess) {
              // updateLocalStorageFromRequest();
              setSnackbar({
                severity: "success",
                isOpen: true,
                description: data.message,
              });
            } else {
              setSnackbar({
                severity: "error",
                isOpen: true,
                description: data.message,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: "İşlem sırasında bir hata oluştu",
            });
          },
        }
      );
    } else {
      addMerchantPartner(request, {
        onSuccess(data) {
          if (data.isSuccess) {
            // updateLocalStorageFromRequest();
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: data.message,
            });
          } else {
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: data.message,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: "İşlem sırasında bir hata oluştu",
          });
        },
      });
    }
  };

  useEffect(() => {
    if (!!merchant && JSON.stringify(merchant) !== "{}") {
      let merchantDataFromCache: any = null;
      try {
        const merchantDataRaw = localStorage.getItem("merchantData");
        if (merchantDataRaw) {
          merchantDataFromCache = JSON.parse(merchantDataRaw);
        }
      } catch (e) {
        // ignore
      }

      const src = (field: string, fallback?: any) =>
      (allData && allData[field] !== undefined
        ? allData[field]
        : merchant && merchant[field] !== undefined
          ? merchant[field]
          : fallback);

      reset({
        officialFullName: src("officialFullName", ""),
        officialCitizenNumber: src("officialCitizenNumber", ""),
        officialMobilePhone: formatPhoneNumber2(src("officialMobilePhone", "")) || "",

        officialBirthDate: src("officialBirthDate")
          ? dayjs(src("officialBirthDate"))
          : null,

        partnerOneFullName: src("partnerOneFullName", "") || "",
        partnerOneCitizenNumber: src("partnerOneCitizenNumber", "") || "",
        // partnerOneMobilePhone: formatPhoneNumber2(src("partnerOneMobilePhone", "")) || "",
        partnerOneBirthDate: src("partnerOneBirthDate")
          ? dayjs(src("partnerOneBirthDate"))
          : null,
        partnerOnePercent: src("partnerOnePercent", 0) || 0,
        partnerOneType: src("partnerOneType", "G") || "G",

        partnerTwoFullName: src("partnerTwoFullName", "") || "",
        partnerTwoCitizenNumber: src("partnerTwoCitizenNumber", "") || "",
        // partnerTwoMobilePhone: formatPhoneNumber2(src("partnerTwoMobilePhone", "")) || "",
        partnerTwoBirthDate: src("partnerTwoBirthDate")
          ? dayjs(src("partnerTwoBirthDate"))
          : null,
        partnerTwoPercent: src("partnerTwoPercent", 0) || 0,
        partnerTwoType: src("partnerTwoType", "G") || "G",

        partnerThreeFullName: src("partnerThreeFullName", "") || "",
        partnerThreeCitizenNumber: src("partnerThreeCitizenNumber", "") || "",
        // partnerThreeMobilePhone: formatPhoneNumber2(src("partnerThreeMobilePhone", "")) || "",
        partnerThreeBirthDate: src("partnerThreeBirthDate")
          ? dayjs(src("partnerThreeBirthDate"))
          : null,
        partnerThreePercent: src("partnerThreePercent", 0) || 0,
        partnerThreeType: src("partnerThreeType", "G") || "G",

        partnerFourFullName: src("partnerFourFullName", "") || "",
        partnerFourCitizenNumber: src("partnerFourCitizenNumber", "") || "",
        // partnerFourMobilePhone: formatPhoneNumber2(src("partnerFourMobilePhone", "")) || "",
        partnerFourBirthDate: src("partnerFourBirthDate")
          ? dayjs(src("partnerFourBirthDate"))
          : null,
        partnerFourPercent: src("partnerFourPercent", 0) || 0,
        partnerFourType: src("partnerFourType", "G") || "G",

        partnerFiveFullName: src("partnerFiveFullName", "") || "",
        partnerFiveCitizenNumber: src("partnerFiveCitizenNumber", "") || "",
        // partnerFiveMobilePhone: formatPhoneNumber2(src("partnerFiveMobilePhone", "")) || "",
        partnerFiveBirthDate: src("partnerFiveBirthDate")
          ? dayjs(src("partnerFiveBirthDate"))
          : null,
        partnerFivePercent: src("partnerFivePercent", 0) || 0,
        partnerFiveType: src("partnerFiveType", "G") || "G",
      });

      const hasCitizen = (field: string) =>
        !!(merchantDataFromCache && merchantDataFromCache[field]) ||
        !!(merchant && merchant[field]) ||
        !!(allData && allData[field]);

      let filledPartners = 0;
      if (hasCitizen("partnerOneCitizenNumber")) filledPartners++;
      if (hasCitizen("partnerTwoCitizenNumber")) filledPartners++;
      if (hasCitizen("partnerThreeCitizenNumber")) filledPartners++;
      if (hasCitizen("partnerFourCitizenNumber")) filledPartners++;
      if (hasCitizen("partnerFiveCitizenNumber")) filledPartners++;

      setPartnersCount(filledPartners);
    }
  }, [merchant, allData, reset]);

  const PartnerInput = ({ id, name, citizenNumber, mobilePhone, birthDate, percent, type, onDelete }) => (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle1" fontWeight="bold">
          Ortak {id}
        </Typography>
        <Button
          onClick={onDelete}
          variant="outlined"
          color="error"
          text="Sil"
          startIcon={<DeleteIcon />}
        />
      </Stack>
      <Stack
        width={"100%"}
        spacing={3}
        direction={isDesktop ? "row" : "column"}
      >
        <FormControl fullWidth>
          <InputControl
            id={name}
            control={control}
            label={`Ad Soyad`}
          />
        </FormControl>
        <FormControl fullWidth>
          <InputControl
            id={citizenNumber}
            control={control}
            label={`Kimlik Numarası`}
            numeric
            maxLength={11}
          />
        </FormControl>
      </Stack>
      <Stack
        width={"100%"}
        spacing={3}
        direction={isDesktop ? "row" : "column"}
      >
        <FormControl sx={{ width: isDesktop ? '50%' : '100%' }}>
          <DatePickerControl
            id={birthDate}
            control={control}
            label={`Doğum Tarihi`}
            defaultValue={null}
          />
        </FormControl>
        <FormControl sx={{ width: isDesktop ? '50%' : '100%' }}>
          <InputControl
            id={percent}
            control={control}
            label={`Hisse Oranı`}
            numeric
          />
        </FormControl>
      </Stack>
      <Stack
        width={"100%"}
        spacing={3}
        direction={isDesktop ? "row" : "column"}
      >
        <FormControl sx={{ width: isDesktop ? '50%' : '100%' }}>
          <SelectControl
            id={type}
            control={control}
            label={`Tipi`}
            items={partnerTypeOptions}
          />
        </FormControl>
      </Stack>
    </Stack>
  );
  const [partnersCount, setPartnersCount] = React.useState(0);
  const [deleteDialog, setDeleteDialog] = React.useState<{ open: boolean; partnerId: number | null }>({ open: false, partnerId: null });
  const [deleteLoading, setDeleteLoading] = React.useState(false);

  const handleDeletePartner = (partnerId: number) => {
    setDeleteDialog({ open: true, partnerId });
  };

  const { mutate: deleteMerchantPartner } = useMerchantPartnerDelete();


  const confirmDeletePartner = () => {
    const partnerId = deleteDialog.partnerId;
    if (!allData?.merchantId || partnerId === null || partnerId === undefined) return;

    setDeleteLoading(true);
    deleteMerchantPartner(
      {
        merchantId: allData.merchantId,
        partnerOrder: partnerId,
      },
      {
        onSuccess: () => {
          // Form ve cache üzerinde partnerleri sola kaydır
          const formValues = getValues();

          const emptyPartner = {
            fullName: "",
            citizen: "",
            phone: "",
            birth: null,
            percent: 0,
            type: "G",
          };

          const formPartners = [
            {
              fullName: formValues.partnerOneFullName || "",
              citizen: formValues.partnerOneCitizenNumber || "",
              phone: formValues.partnerOneMobilePhone || "",
              birth: formValues.partnerOneBirthDate || null,
              percent: formValues.partnerOnePercent || 0,
              type: formValues.partnerOneType || "G",
            },
            {
              fullName: formValues.partnerTwoFullName || "",
              citizen: formValues.partnerTwoCitizenNumber || "",
              phone: formValues.partnerTwoMobilePhone || "",
              birth: formValues.partnerTwoBirthDate || null,
              percent: formValues.partnerTwoPercent || 0,
              type: formValues.partnerTwoType || "G",
            },
            {
              fullName: formValues.partnerThreeFullName || "",
              citizen: formValues.partnerThreeCitizenNumber || "",
              phone: formValues.partnerThreeMobilePhone || "",
              birth: formValues.partnerThreeBirthDate || null,
              percent: formValues.partnerThreePercent || 0,
              type: formValues.partnerThreeType || "G",
            },
            {
              fullName: formValues.partnerFourFullName || "",
              citizen: formValues.partnerFourCitizenNumber || "",
              phone: formValues.partnerFourMobilePhone || "",
              birth: formValues.partnerFourBirthDate || null,
              percent: formValues.partnerFourPercent || 0,
              type: formValues.partnerFourType || "G",
            },
            {
              fullName: formValues.partnerFiveFullName || "",
              citizen: formValues.partnerFiveCitizenNumber || "",
              phone: formValues.partnerFiveMobilePhone || "",
              birth: formValues.partnerFiveBirthDate || null,
              percent: formValues.partnerFivePercent || 0,
              type: formValues.partnerFiveType || "G",
            },
          ];

          const newFormPartners = [...formPartners];
          newFormPartners.splice(partnerId - 1, 1);
          newFormPartners.push(emptyPartner);

          // Form değerlerini yeni sıraya göre güncelle
          setValue("partnerOneFullName", newFormPartners[0].fullName);
          setValue("partnerOneCitizenNumber", newFormPartners[0].citizen);
          setValue("partnerOneMobilePhone", newFormPartners[0].phone);
          setValue("partnerOneBirthDate", newFormPartners[0].birth);
          setValue("partnerOnePercent", newFormPartners[0].percent);
          setValue("partnerOneType", newFormPartners[0].type);

          setValue("partnerTwoFullName", newFormPartners[1].fullName);
          setValue("partnerTwoCitizenNumber", newFormPartners[1].citizen);
          setValue("partnerTwoMobilePhone", newFormPartners[1].phone);
          setValue("partnerTwoBirthDate", newFormPartners[1].birth);
          setValue("partnerTwoPercent", newFormPartners[1].percent);
          setValue("partnerTwoType", newFormPartners[1].type);

          setValue("partnerThreeFullName", newFormPartners[2].fullName);
          setValue("partnerThreeCitizenNumber", newFormPartners[2].citizen);
          setValue("partnerThreeMobilePhone", newFormPartners[2].phone);
          setValue("partnerThreeBirthDate", newFormPartners[2].birth);
          setValue("partnerThreePercent", newFormPartners[2].percent);
          setValue("partnerThreeType", newFormPartners[2].type);

          setValue("partnerFourFullName", newFormPartners[3].fullName);
          setValue("partnerFourCitizenNumber", newFormPartners[3].citizen);
          setValue("partnerFourMobilePhone", newFormPartners[3].phone);
          setValue("partnerFourBirthDate", newFormPartners[3].birth);
          setValue("partnerFourPercent", newFormPartners[3].percent);
          setValue("partnerFourType", newFormPartners[3].type);

          setValue("partnerFiveFullName", newFormPartners[4].fullName);
          setValue("partnerFiveCitizenNumber", newFormPartners[4].citizen);
          setValue("partnerFiveMobilePhone", newFormPartners[4].phone);
          setValue("partnerFiveBirthDate", newFormPartners[4].birth);
          setValue("partnerFivePercent", newFormPartners[4].percent);
          setValue("partnerFiveType", newFormPartners[4].type);

          // localStorage tarafını da kaydır
          try {
            const merchantDataRaw = localStorage.getItem("merchantData");
            if (merchantDataRaw) {
              const merchantData = JSON.parse(merchantDataRaw);
              const cachePartners = [
                {
                  fullName: merchantData["partnerOneFullName"] || "",
                  citizen: merchantData["partnerOneCitizenNumber"] || "",
                  phone: merchantData["partnerOneMobilePhone"] || "",
                  birth: merchantData["partnerOneBirthDate"] || null,
                  percent: merchantData["partnerOnePercent"] || 0,
                  type: merchantData["partnerOneType"] || "G",
                },
                {
                  fullName: merchantData["partnerTwoFullName"] || "",
                  citizen: merchantData["partnerTwoCitizenNumber"] || "",
                  phone: merchantData["partnerTwoMobilePhone"] || "",
                  birth: merchantData["partnerTwoBirthDate"] || null,
                  percent: merchantData["partnerTwoPercent"] || 0,
                  type: merchantData["partnerTwoType"] || "G",
                },
                {
                  fullName: merchantData["partnerThreeFullName"] || "",
                  citizen: merchantData["partnerThreeCitizenNumber"] || "",
                  phone: merchantData["partnerThreeMobilePhone"] || "",
                  birth: merchantData["partnerThreeBirthDate"] || null,
                  percent: merchantData["partnerThreePercent"] || 0,
                  type: merchantData["partnerThreeType"] || "G",
                },
                {
                  fullName: merchantData["partnerFourFullName"] || "",
                  citizen: merchantData["partnerFourCitizenNumber"] || "",
                  phone: merchantData["partnerFourMobilePhone"] || "",
                  birth: merchantData["partnerFourBirthDate"] || null,
                  percent: merchantData["partnerFourPercent"] || 0,
                  type: merchantData["partnerFourType"] || "G",
                },
                {
                  fullName: merchantData["partnerFiveFullName"] || "",
                  citizen: merchantData["partnerFiveCitizenNumber"] || "",
                  phone: merchantData["partnerFiveMobilePhone"] || "",
                  birth: merchantData["partnerFiveBirthDate"] || null,
                  percent: merchantData["partnerFivePercent"] || 0,
                  type: merchantData["partnerFiveType"] || "G",
                },
              ];

              const newCachePartners = [...cachePartners];
              newCachePartners.splice(partnerId - 1, 1);
              newCachePartners.push(emptyPartner);

              merchantData["partnerOneFullName"] = newCachePartners[0].fullName;
              merchantData["partnerOneCitizenNumber"] = newCachePartners[0].citizen;
              merchantData["partnerOneMobilePhone"] = newCachePartners[0].phone;
              merchantData["partnerOneBirthDate"] = newCachePartners[0].birth;
              merchantData["partnerOnePercent"] = newCachePartners[0].percent;
              merchantData["partnerOneType"] = newCachePartners[0].type;

              merchantData["partnerTwoFullName"] = newCachePartners[1].fullName;
              merchantData["partnerTwoCitizenNumber"] = newCachePartners[1].citizen;
              merchantData["partnerTwoMobilePhone"] = newCachePartners[1].phone;
              merchantData["partnerTwoBirthDate"] = newCachePartners[1].birth;
              merchantData["partnerTwoPercent"] = newCachePartners[1].percent;
              merchantData["partnerTwoType"] = newCachePartners[1].type;

              merchantData["partnerThreeFullName"] = newCachePartners[2].fullName;
              merchantData["partnerThreeCitizenNumber"] = newCachePartners[2].citizen;
              merchantData["partnerThreeMobilePhone"] = newCachePartners[2].phone;
              merchantData["partnerThreeBirthDate"] = newCachePartners[2].birth;
              merchantData["partnerThreePercent"] = newCachePartners[2].percent;
              merchantData["partnerThreeType"] = newCachePartners[2].type;

              merchantData["partnerFourFullName"] = newCachePartners[3].fullName;
              merchantData["partnerFourCitizenNumber"] = newCachePartners[3].citizen;
              merchantData["partnerFourMobilePhone"] = newCachePartners[3].phone;
              merchantData["partnerFourBirthDate"] = newCachePartners[3].birth;
              merchantData["partnerFourPercent"] = newCachePartners[3].percent;
              merchantData["partnerFourType"] = newCachePartners[3].type;

              merchantData["partnerFiveFullName"] = newCachePartners[4].fullName;
              merchantData["partnerFiveCitizenNumber"] = newCachePartners[4].citizen;
              merchantData["partnerFiveMobilePhone"] = newCachePartners[4].phone;
              merchantData["partnerFiveBirthDate"] = newCachePartners[4].birth;
              merchantData["partnerFivePercent"] = newCachePartners[4].percent;
              merchantData["partnerFiveType"] = newCachePartners[4].type;

              localStorage.setItem("merchantData", JSON.stringify(merchantData));
              setAllData({ ...allData, ...merchantData });
            }
          } catch (e) {
            // ignore
          }

          // partner sayısını yeniden hesapla
          const activePartners = newFormPartners.filter(
            (p) => p.fullName || p.citizen || p.phone || p.percent
          ).length;
          setPartnersCount(activePartners);

          setSnackbar({
            severity: "success",
            isOpen: true,
            description: "Ortak başarıyla silindi",
          });
          setDeleteDialog({ open: false, partnerId: null });
          setDeleteLoading(false);
        },
        onError: (err) => {
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: err?.message || "Ortak silinemedi!",
          });
          setDeleteDialog({ open: false, partnerId: null });
          setDeleteLoading(false);
        },
      }
    );
  };

  const addPartner = () => {
    if (partnersCount < 5) {
      setPartnersCount(partnersCount + 1);
    } else {
      setSnackbar({
        severity: "error",
        isOpen: true,
        description: "5 ortaktan fazla ekleyemezsiniz",
      });
    }
  };

  const renderPartners = () => {
    const names = [
      "partnerOneFullName",
      "partnerTwoFullName",
      "partnerThreeFullName",
      "partnerFourFullName",
      "partnerFiveFullName",
    ];
    const citizenNumber = [
      "partnerOneCitizenNumber",
      "partnerTwoCitizenNumber",
      "partnerThreeCitizenNumber",
      "partnerFourCitizenNumber",
      "partnerFiveCitizenNumber",
    ];
    const mobilePhone = [
      "partnerOneMobilePhone",
      "partnerTwoMobilePhone",
      "partnerThreeMobilePhone",
      "partnerFourMobilePhone",
      "partnerFiveMobilePhone",
    ];
    const birthDate = [
      "partnerOneBirthDate",
      "partnerTwoBirthDate",
      "partnerThreeBirthDate",
      "partnerFourBirthDate",
      "partnerFiveBirthDate",
    ];
    const percent = [
      "partnerOnePercent",
      "partnerTwoPercent",
      "partnerThreePercent",
      "partnerFourPercent",
      "partnerFivePercent",
    ];
    const type = [
      "partnerOneType",
      "partnerTwoType",
      "partnerThreeType",
      "partnerFourType",
      "partnerFiveType",
    ];
    let partners = [];
    for (let i = 0; i < partnersCount; i++) {
      partners.push(
        <PartnerInput
          key={i}
          id={i + 1}
          name={names[i]}
          citizenNumber={citizenNumber[i]}
          mobilePhone={mobilePhone[i]}
          birthDate={birthDate[i]}
          percent={percent[i]}
          type={type[i]}
          onDelete={() => handleDeletePartner(i + 1)}
        />
      );
    }
    return partners;
  };

  return (
    <>
      {isLoading && <Loading />}
      <Box p={isDesktop ? 3 : 2}>
        <Stack spacing={3}>
          <Card variant="outlined">
            <CardHeader title="Yetkili Kişi Bilgileri" />
            <CardContent>
              <Stack spacing={3}>
                <Stack
                  width={"100%"}
                  spacing={3}
                  direction={isDesktop ? "row" : "column"}
                >
                  <FormControl fullWidth>
                    <InputControl
                      id="officialFullName"
                      control={control}
                      label="Yetkili Kişi Ad Soyad"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <InputControl
                      id="officialCitizenNumber"
                      control={control}
                      label="Yetkili Kişi Kimlik Numarası"
                      numeric
                      maxLength={11}
                    />
                  </FormControl>
                </Stack>
                <Stack
                  width={"100%"}
                  spacing={3}
                  direction={isDesktop ? "row" : "column"}
                >
                  <FormControl fullWidth>
                    <FormatInputControl
                      defaultValue=""
                      label="Yetkili Kişi Telefon Numarası"
                      control={control}
                      id="officialMobilePhone"
                      allowEmptyFormatting
                      mask="_"
                      adornmentText="0"
                      isDisabled={false}
                      format="(###) ### ## ##"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <DatePickerControl
                      id="officialBirthDate"
                      control={control}
                      label="Yetkili Kişi Doğum Tarihi"
                      defaultValue={null}
                    />
                  </FormControl>
                </Stack>
              </Stack>
            </CardContent>
          </Card>

          <Card variant="outlined">
            <CardHeader
              title="Ortak Bilgileri"
              action={
                <Button
                  variant="outlined"
                  text="+ Ortak Ekle"
                  onClick={addPartner}
                />
              }
            />
            <CardContent>
              {partnersCount > 0 ? (
                <Stack spacing={4} divider={<Divider sx={{ my: 2 }} />}>
                  {renderPartners()}
                </Stack>
              ) : (
                <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ py: 4 }}>
                  Eklenmiş ortak bulunmamaktadır.
                </Typography>
              )}
            </CardContent>
          </Card>

          <Stack direction="row" justifyContent="flex-end">
            <Button
              variant="contained"
              text="Kaydet ve Güncelle"
              onClick={handleSubmit(onSubmit)}
            />
          </Stack>
        </Stack>
      </Box>

      <Dialog
        open={deleteDialog.open}
        onClose={() => setDeleteDialog({ open: false, partnerId: null })}
      >
        <DialogTitle>Ortağı Sil</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Bu ortağı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            text="İptal"
            onClick={() => setDeleteDialog({ open: false, partnerId: null })}
            variant="outlined"
            disabled={deleteLoading}
          />
          <Button
            text={deleteLoading ? "Siliniyor..." : "Sil"}
            onClick={confirmDeletePartner}
            variant="contained"
            color="error"
            disabled={deleteLoading}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};
